import {Component, Input} from '@angular/core';
import {WaaHeader} from "./models/widget-app-assessment-v0-args.dto";
import {IoniconsFilled, ND} from '@pt/pt-models';

@Component({
  selector: 'pt-waa-edit-row-col2',
  template: `
    <div>
      {{ description ? description : ND }}
      <pt-w-help [help]='help'></pt-w-help>
    </div>
    <div class="action waa-action-container">
      <div class='badge rounded-pill badge-light me-2 badge-ellipse'
           *ngIf="normativeReference"
           container='body'
           ngbTooltip="{{normativeReference}}"
           style="border: 1px solid #333333; color: #333333">
        {{ normativeReference }}
      </div>
      <div class='badge rounded-pill badge-light me-2 badge-ellipse'
           container='body'
           ngbTooltip="{{category ? category : ND}}"
           style="border: 1px solid orange; color: #333333">
        {{ category ? category : ND }}
      </div>
      <button *ngIf='scenarioR || scenarioD || scenarioI' container='body'
              [ngbPopover]='relatedScenario'
              class='btn btn-sm btn-outline-primary relatedScenario badge-ellipse'>
        {{ header.relatedScenarios }}
      </button>

      <ng-template #relatedScenario>
        <div class='d-flex w-100 flex-column'>
          <div class='d-flex flex-row'>
            <pt-icon
              [ngClass]="{'waa-with-scenario': scenarioR, 'waa-no-scenario': !scenarioR}"
              [key]='scenarioR ? IconRadiobutton : IconRadioUnchecked'></pt-icon>
            <div>{{ header.scenarioR }}</div>
          </div>
          <div class='d-flex flex-row'>
            <pt-icon
              [ngClass]="{'waa-with-scenario': scenarioI, 'waa-no-scenario': !scenarioI}"
              [key]='scenarioI ? IconRadiobutton : IconRadioUnchecked'></pt-icon>
            <div>{{ header.scenarioI }}</div>
          </div>
          <div class='d-flex flex-row'>
            <pt-icon
              [ngClass]="{'waa-with-scenario': scenarioD, 'waa-no-scenario': !scenarioD}"
              [key]='scenarioD ? IconRadiobutton : IconRadioUnchecked'></pt-icon>
            <div>{{ header.scenarioD }}</div>
          </div>
        </div>
      </ng-template>
    </div>
  `,
  styles: [`
    .relatedScenario {
      font-size: 12px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 1px 4px;
      margin: 0;
    }
    .waa-action-container {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-top: 5px;
    }

    .waa-with-scenario {
      color: #4CAF50;
    }

    .waa-no-scenario {
      color: #d4d4d4;
    }

    .badge-ellipse {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 250px;
      /*padding: 0 10px;*/
      /*border: 1px solid #333333;*/
      /*font-size: 10px;*/
      /*border-radius: 10px;*/
      /*color: #333333;*/
    }

  `],
})
export class WaaEditRowCol2Component {
  @Input() description?: string;
  @Input() scenarioR: boolean;
  @Input() scenarioI: boolean;
  @Input() scenarioD: boolean;
  @Input() normativeReference?: string;
  @Input() category?: string;
  @Input() help?: string;
  @Input() header: WaaHeader;

  IconRadiobutton = IoniconsFilled.radiobutton;
  IconRadioUnchecked = IoniconsFilled.radioUnchecked;
  ND = ND;

}
